import Complain from '../pages/complain/Complain'

const redirectRoutes = [{index: true, element: <Complain />}]

export default redirectRoutes
